import React from "react";
import { useTranslation } from "react-i18next";
import { Typography11, Typography14, Typography12, Typography24 } from "@slid/slid-ips";
import styled from "styled-components";
import { MediumNoteMateIcon } from "components/icons/NoteMateIcons/MediumNoteMateIcon";

export const DesktopNewChatPlaceholder = ({ handlePlaceholderClick }: { handlePlaceholderClick: (content: { title: string; question: string; type?: string }, index: number) => void }) => {
  const { t } = useTranslation("NoteMate");

  const placeholderList = t("DesktopPlaceholderList", { returnObjects: true }) as { title: string; question: string }[];

  return (
    <NewChatPlaceholderContainer>
      <PlaceholderHeader>
        <MediumNoteMateIcon />
        <PlaceholderTitle>
          <Typography24 weight={700} color={"--gray18"} text={t("PlaceholderTitle")} />
          <Typography14 weight={400} color={"--gray7"} text={t("PlaceholderContent")} />
        </PlaceholderTitle>
      </PlaceholderHeader>
      <PlaceholderContent>
        {placeholderList.map((content, index) => (
          <PlaceholderContentItem key={index} onClick={() => handlePlaceholderClick(content, index)}>
            <Typography11 weight={500} color={"--blue7"} text={content.title} />
            <Typography12 weight={500} color={"--gray15"} text={content.question} />
          </PlaceholderContentItem>
        ))}
      </PlaceholderContent>
    </NewChatPlaceholderContainer>
  );
};

const NewChatPlaceholderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  background-color: var(--white);
`;

const PlaceholderHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const PlaceholderTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const PlaceholderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const PlaceholderContentItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  border-radius: 12px;
  gap: 2px;
  cursor: pointer;
  background-color: #ebf6ff;

  :hover {
    background-color: var(--blue3);
  }
  :active {
    background-color: var(--blue3);
  }
`;
